.container-compartment{display:flex;flex-direction:column;max-width:500px}.container-compartment>*{width:100%}.form{display:flex;padding-top:6px}
/*# sourceMappingURL=container-compartment.component-FF66BOPV.css.map */
